import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Componets/Header";
import InquiryPopup from "../Componets/InquiryPopup";
import Footer from "../Componets/Footer";
import { Helmet } from "react-helmet-async";

function Home() {
  const [loading, setLoading] = useState(true);
  const [successMsg, setSuccessMsg] = useState("");
  const [fromdata, setdfromdata] = useState({
    username: "",
    email: "",
    mobileno: "",
    message: "",
  });

  const handlechange = (e) => {
    setdfromdata({ ...fromdata, [e.target.name]: e.target.value });
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    if (
      !fromdata.username ||
      !fromdata.email ||
      !fromdata.mobileno ||
      !fromdata.message
    ) {
      alert("Please fill all fields");
      return;
    }

    setLoading(false);

    try {
      const res = await fetch("http://localhost:5000/send", {
        method: "Post",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(fromdata),
      });
      const data = await res.json();
      if (data.success) {
        setdfromdata({ username: "", email: "", mobileno: "", message: "" });
        setSuccessMsg("Message sent successfully");
      } else {
        alert("failed message");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Preloader timer
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const phoneNumber = "8487892218";
  const message = "Hello! I want to chat with you.";

  const handleClick = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const url = isMobile
      ? `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(
          message
        )}`
      : `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
    console.log("click");
  };

  return (
    <>
      {/* {loading ? ( */}
      {/* //  <!-- preloader start --> */}
      {loading && (
        <div id="pre-load">
          <div id="loader" className="loader">
            <div className="loader-container">
              <div className="loader-icon">
                <img src="/assets/images/favicon.png" alt="Loader" />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <div id="pre-load">
          <div id="loader" className="loader">
            <div className="loader-container has-theme-red">
              <div className="loader-icon">
                <img src="/assets/images/favicon-red.png" alt="" />
              </div>
            </div>
          </div>
        </div> */}
      {/* ) : ( */}
      {/* //  <!-- preloader end --> */}

      {/* // header area start */}
      <>
        <Header />

        <Helmet>
          <title>
            {`Home | ${process.env.REACT_APP_COMPANYNAME} | ${process.env.REACT_APP_PHONE1}`}
          </title>

          <meta
            name="description"
            content="Manufacturer of high-precision cutting tools for CNC & VMC machining applications."
          />

          <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL}/`} />

          <meta
            property="og:url"
            content={`${process.env.REACT_APP_SITE_URL}/`}
          />

          <meta
            property="og:title"
            content={`Pristine Precision Tools | CNC & VMC Cutting Tools`}
          />

          <meta
            property="og:description"
            content="Manufacturer of high-precision cutting tools for CNC & VMC machining applications."
          />

          <meta property="og:type" content="website" />
        </Helmet>

        {/* // header area end */}

        <main>
          {/* <!-- banner area start --> */}
          <section className="rs-banner-area rs-banner-four p-relative rs-swiper">
            {/* <div className="rs-banner-stroke-text">
              <span>Metal</span>
            </div> */}
            <div className="rs-banner-slider-wrapper">
              <div
                className="swiper"
                data-clone-slides="false"
                data-loop="true"
                data-speed="2000"
                data-autoplay="true"
                data-dots-dynamic="false"
                data-hover-pause="true"
                data-effect="fade"
                data-delay="1000"
                data-item="1"
                data-item-xl="1"
                data-item-lg="1"
                data-item-md="1"
                data-item-sm="1"
                data-item-xs="1"
                data-item-mobile="1"
                data-margin="30"
                data-margin-xl="30"
                data-margin-lg="30"
                data-margin-md="30"
                data-margin-sm="30"
                data-margin-xs="30"
                data-margin-mobile="30"
              >
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="rs-banner-item-wrapper">
                      {/* <div
                        className="rs-banner-bg-thumb"
                        style={{
                          backgroundImage:
                            "url(/assets/images/bg/img_slider_1.jpg)",
                        }}
                      ></div> */}
                      <div className="rs-banner-bg-thumb">
                        <picture>
                          <source
                            srcSet="/assets/images/bg/img_slider_mobile_1.jpg"
                            media="(max-width:  480px)"
                            type="image/webp"
                          />

                          <img
                            src="/assets/images/bg/img_slider_1.jpg"
                            alt="Vacuum Wax Injector – Pristine Precision Tools"
                            className="banner-img"
                            loading="eager"
                          />
                        </picture>
                      </div>

                      <div className="container">
                        <div className="row">
                          <div className="col-xxl-8 col-xl-10 col-lg-11">
                            <div className="rs-banner-item">
                              <div className="rs-banner-content">
                                <span className="rs-banner-subtitle">
                                  Shaping the Future of Metals
                                </span>
                                <h1 className="rs-banner-title">
                                  High-Precision Cutting Tools for CNC & VMC
                                </h1>
                                <div className="rs-banner-descrip">
                                  <p>
                                    Precision cutting and drilling tools for CNC
                                    & VMC machining. Built for accuracy and
                                    durability.
                                  </p>
                                </div>
                                <div className="rs-banner-btn">
                                  <Link
                                    className="rs-btn has-theme-red has-icon has-bg has-skew"
                                    to="/product"
                                    title="pristine precision tools contact"
                                  >
                                    Explore More
                                    <span className="icon-box">
                                      <svg
                                        className="icon-first"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32"
                                      >
                                        <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                      </svg>
                                      <svg
                                        className="icon-second"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32"
                                      >
                                        <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                      </svg>
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="rs-banner-item-wrapper">
                      {/* <div className="rs-banner-bg-thumb" data-background="assets/images/bg/banner-bg-06.png">
                                </div> */}
                      {/* <div
                        className="rs-banner-bg-thumb"
                        style={{
                          backgroundImage:
                            "url(/assets/images/bg/img_slider_2.jpg)",
                        }}
                      ></div> */}
                      <div className="rs-banner-bg-thumb">
                        <picture>
                          <source
                            srcSet="/assets/images/bg/img_slider_mobile_2.jpg"
                            media="(max-width:  480px)"
                            type="image/webp"
                          />

                          <img
                            src="/assets/images/bg/img_slider_2.jpg"
                            alt="Vacuum Wax Injector – Pristine Precision Tools"
                            className="banner-img"
                            loading="eager"
                          />
                        </picture>
                      </div>

                      <div className="container">
                        <div className="row">
                          <div className="col-xxl-8 col-xl-10 col-lg-11">
                            <div className="rs-banner-item">
                              <div className="rs-banner-content">
                                <span className="rs-banner-subtitle">
                                  Shaping the Future of Metals
                                </span>
                                <h1 className="rs-banner-title">
                                  Innovative Metallurgy for Precision
                                  Manufacturing
                                </h1>
                                <div className="rs-banner-descrip">
                                  <p>
                                    We solve worldwide industrial every problem,
                                    the heart of global landscape the industry
                                    stands multidimensional was progress
                                  </p>
                                </div>
                                <div className="rs-banner-btn">
                                  <Link
                                    className="rs-btn has-theme-red has-icon has-bg has-skew"
                                    to="/contact"
                                    title="pristine precision tools contact"
                                  >
                                    Explore More
                                    <span className="icon-box">
                                      <svg
                                        className="icon-first"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32"
                                      >
                                        <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                      </svg>
                                      <svg
                                        className="icon-second"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 32 32"
                                      >
                                        <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                      </svg>
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- If we need navigation buttons --> */}
                <div className="rs-banner-navigation">
                  <button className="swiper-button-prev rs-swiper-btn has-theme-red">
                    <i className="fa-regular fa-arrow-left"></i>
                  </button>
                  <button className="swiper-button-next rs-swiper-btn has-theme-red">
                    <i className="fa-regular fa-arrow-right"></i>
                  </button>
                </div>
                {/* <!-- if we need pagination --> */}
                <div className="rs-banner-pagination d-block d-md-none">
                  <div className="swiper-pagination rs-pagination has-theme-red"></div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- banner area end -->

           <!-- about area start --> */}
          <section
            id="homeabout"
            className="rs-about-area section-space-bottom rs-about-eight has-theme-green"
          >
            <div className="container">
              <div className="row g-5">
                <div className="col-xl-6 col-lg-5">
                  <div className="rs-about-thumb-wrapper">
                    {/* <div className="rs-about-shape-one">
                      <img src="assets/images/img_about3.png" alt="image" />
                    </div> */}
                    <div className="rs-about-shape-two">
                      <img
                        src="assets/images/shape/line-shape.png"
                        alt="image"
                      />
                    </div>
                    <div className="rs-about-thumb img-one">
                      <img src="assets/images/img_about2.jpg" alt="image" />
                    </div>

                    <div className="rs-about-thumb img-two">
                      <img
                        src="assets/images/about/about-thumb-21.png"
                        alt="image"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-7">
                  <div className="rs-about-wrapper">
                    <div className="rs-about-content-wrapper">
                      <div className="rs-section-title-wrapper">
                        <span className="rs-section-subtitle has-theme-light-green justify-content-start">
                          About industrie
                        </span>
                        <h2 className="rs-section-title has-theme-green rs-split-text-enable split-in-fade">
                          <span className="heading-highlight">
                            Precision Cutting Tools
                          </span>
                          Manufacturer
                        </h2>
                        <p className="descrip">
                          Pristine Precision Tools is a trusted manufacturer of
                          precision cutting tools and drilling tools designed
                          for high-performance CNC and VMC machining. We deliver
                          advanced solid carbide cutting solutions that help
                          manufacturers achieve superior accuracy, efficiency,
                          and long tool life.
                        </p>
                      </div>
                      <div className="rs-about-feature-list">
                        <div className="rs-list-item has-theme-green">
                          <ul>
                            <li>
                              <i className="fa-regular fa-check"></i>
                              Quality Control System
                            </li>
                            <li>
                              <i className="fa-regular fa-check"></i>
                              Building Quality Industrial Solutions
                            </li>
                            <li>
                              <i className="fa-regular fa-check"></i>
                              Precision Engineering Expertise
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="rs-about-author-info">
                        <div className="rs-about-btn">
                          <Link
                            className="rs-btn has-theme-light-green has-icon has-bg"
                            to="/about"
                          >
                            Explore More
                            <span className="icon-box">
                              <svg
                                className="icon-first"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 32 32"
                              >
                                <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                              </svg>
                              <svg
                                className="icon-second"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 32 32"
                              >
                                <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                              </svg>
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- about area end -->

        <!-- feature area start --> */}

          <div className="rs-feature-area rs-feature-three">
            <div className="rs-section-title-wrapper section-title-space text-center">
              {/* <span className="rs-section-subtitle  has-bg-field">
                      our Porduct
                    </span> */}
              <h2 className="rs-section-title rs-split-text-enable split-in-fade text-white">
                Core <span className="heading-highlight">Expertise</span>{" "}
              </h2>
            </div>

            <div className="rs-feature-bg-thumb"></div>

            <div className="container">
              <div className="row g-5">
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div
                    className="rs-feature-item wow fadeInUp"
                    data-wow-delay=".3s"
                    data-wow-duration="1s"
                  >
                    <div className="rs-feature-icon">
                      <img
                        src="/assets/images/icon/feature-icon-17.png"
                        alt="image"
                      />
                    </div>
                    <div className="rs-feature-content">
                      <h5 className="rs-feature-title">
                        High-Accuracy Tool Manufacturing
                      </h5>
                      <div className="rs-feature-descrip">
                        <p>
                          High-accuracy cutting tools for CNC & VMC machining.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div
                    className="rs-feature-item wow fadeInUp"
                    data-wow-delay=".5s"
                    data-wow-duration="1s"
                  >
                    <div className="rs-feature-icon">
                      <img
                        src="/assets/images/icon/feature-icon-18.png"
                        alt="image"
                      />
                    </div>
                    <div className="rs-feature-content">
                      <h5 className="rs-feature-title">
                        Engineered for Consistent Quality
                      </h5>
                      <div className="rs-feature-descrip">
                        <p>
                          Engineered for consistent quality, durability, and
                          long tool life.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div
                    className="rs-feature-item wow fadeInUp"
                    data-wow-delay=".7s"
                    data-wow-duration="1s"
                  >
                    <div className="rs-feature-icon">
                      <img
                        src="/assets/images/icon/feature-icon-19.png"
                        alt="image"
                      />
                    </div>
                    <div className="rs-feature-content">
                      <h5 className="rs-feature-title">
                        Next-Generation Machining Solutions
                      </h5>
                      <div className="rs-feature-descrip">
                        <p>
                          Advanced cutting tools for improved efficiency and
                          productivity.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- feature area end -->

       
          
        

        <!-- Product area start --> */}

          <section className="rs-category-area rs-category-one section-space primary-bg">
            <div className="container">
              <div className="row justify-content-center g-5">
                <div className="col-xl-8 col-lg-8">
                  <div className="rs-section-title-wrapper section-title-space text-center">
                    {/* <span className="rs-section-subtitle  has-bg-field">
                      our Porduct
                    </span> */}
                    <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                      Featured{" "}
                      <span className="heading-highlight">Products</span>{" "}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="rs-category-bg-thumb"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/bg/category-bg-01.png)`,
              }}
            ></div>

            {/* redesign */}
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-6  col-xl-4 col-sm-6 product-mb">
                  <Link to="/high-performance-drills">
                    <div className="product_box_wrap">
                      <div
                        className="product_box2 aos-init aos-animate"
                        data-aos="fade-up"
                        data-aos-duration="500"
                      >
                        <img
                          src="/assets/images/pristine-product/drills.png"
                          alt="High Performance Drills"
                        />
                        {/* <Link to="https://engineerable.co.uk/product-type/chamfer-tools"> */}
                        <div className="product-footer">
                          <h4>High Performance Drills</h4>
                          {/* <p className="m-0 w-75">
                      {" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting
                    </p> */}
                          <div className="rs-portfolio-btn d-flex justify-content-end">
                            <Link
                              className="rs-btn has-theme-red has-circle has-icon product-link-arrow me-3"
                              to="/high-performance-drills"
                            >
                              <span className="icon-box">
                                <svg
                                  className="icon-first"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                                <svg
                                  className="icon-second"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-md-6  col-xl-4 col-sm-6 product-mb">
                  <Link to="/high-performance-endmills">
                    <div className="product_box_wrap ">
                      {" "}
                      <div
                        className="product_box2 aos-init aos-animate"
                        data-aos="fade-up"
                        data-aos-duration="500"
                      >
                        <img
                          src="/assets/images/pristine-product/Endmills.png"
                          alt="High Performance Endmills"
                        />
                        {/* <Link to="https://engineerable.co.uk/product-type/chamfer-tools"> */}

                        <div className="product-footer">
                          <h4>
                            High Performance <br /> Endmills
                          </h4>
                          {/* <p className="m-0 w-75">
                      {" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting
                    </p> */}
                          <div className="rs-portfolio-btn d-flex justify-content-end">
                            <Link
                              className="rs-btn has-theme-red has-circle has-icon product-link-arrow me-3"
                              to="/high-performance-endmills"
                            >
                              <span className="icon-box">
                                <svg
                                  className="icon-first"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                                <svg
                                  className="icon-second"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-md-6  col-xl-4 col-sm-6 product-mb">
                  <Link to="/Chamfer-Tools">
                    <div className="product_box_wrap">
                      {" "}
                      <div
                        className="product_box2 aos-init aos-animate"
                        data-aos="fade-up"
                        data-aos-duration="500"
                      >
                        <img
                          src="/assets/images/pristine-product/champer-tools.png"
                          alt="Chamfer Tools"
                        />
                        {/* <Link to="https://engineerable.co.uk/product-type/chamfer-tools"> */}
                        <div className="product-footer">
                          <h4>Chamfer Tools</h4>
                          {/* <p className="m-0 w-75">
                      {" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting
                    </p> */}
                          <div className="rs-portfolio-btn d-flex justify-content-end">
                            <Link
                              className="rs-btn has-theme-red has-circle has-icon product-link-arrow me-3"
                              to="/Chamfer-Tools"
                            >
                              <span className="icon-box">
                                <svg
                                  className="icon-first"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                                <svg
                                  className="icon-second"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-lg-4 col-md-6  col-xl-4 col-sm-6 product-mb">
                  <Link to="/customized-tools">
                    <div className="product_box_wrap">
                      {" "}
                      <div
                        className="product_box2 aos-init aos-animate"
                        data-aos="fade-up"
                        data-aos-duration="500"
                      >
                        <img
                          src="/assets/images/pristine-product/customize-tools.png"
                          alt="Customize Tools"
                        />
                        {/* <Link to="https://engineerable.co.uk/product-type/chamfer-tools"> */}
                        <div className="product-footer">
                          <h4>Customized Tools</h4>
                          {/* <p className="m-0 w-75">
                      {" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting
                    </p> */}
                          <div className="rs-portfolio-btn d-flex justify-content-end">
                            <Link
                              className="rs-btn has-theme-red has-circle has-icon product-link-arrow me-3"
                              to="/customized-tools"
                            >
                              <span className="icon-box">
                                <svg
                                  className="icon-first"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                                <svg
                                  className="icon-second"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-md-6  col-xl-4 col-sm-6  product-mb">
                  <Link to="/ballnose-endmills">
                    <div className="product_box_wrap">
                      <div
                        className="product_box2 aos-init aos-animate"
                        data-aos="fade-up"
                        data-aos-duration="500"
                      >
                        <img
                          src="/assets/images/pristine-product/ballnose-tools.png"
                          alt="Ballnose Tools"
                        />
                        {/* <Link to="https://engineerable.co.uk/product-type/chamfer-tools"> */}
                        <div className="product-footer">
                          <h4>Ballnose Endmills</h4>
                          {/* <p className="m-0 w-75">
                      {" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting
                    </p> */}
                          <div className="rs-portfolio-btn d-flex justify-content-end">
                            <Link
                              className="rs-btn has-theme-red has-circle has-icon product-link-arrow me-3"
                              to="/ballnose-endmills"
                            >
                              <span className="icon-box">
                                <svg
                                  className="icon-first"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                                <svg
                                  className="icon-second"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-md-6  col-xl-4 col-sm-6  product-mb">
                  <Link to="/reamer">
                    <div className="product_box_wrap">
                      <div
                        className="product_box2 aos-init aos-animate"
                        data-aos="fade-up"
                        data-aos-duration="500"
                      >
                        <img
                          src="/assets/images/pristine-product/reamer.png"
                          alt="Reamer"
                        />
                        {/* <Link to="https://engineerable.co.uk/product-type/chamfer-tools"> */}
                        <div className="product-footer">
                          <h4>Reamer</h4>
                          {/* <p className="m-0 w-75">
                      {" "}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting
                    </p> */}
                          <div className="rs-portfolio-btn d-flex justify-content-end">
                            <Link
                              className="rs-btn has-theme-red has-circle has-icon product-link-arrow me-3"
                              to="/reamer"
                            >
                              <span className="icon-box">
                                <svg
                                  className="icon-first"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                                <svg
                                  className="icon-second"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- Product area end --> */}

          {/* <!-- portfolio area start --> */}
          <section className="rs-portfolio-area rs-portfolio-three section-space-bottom">
            <div className="container">
              <div className="row justify-content-center g-5">
                <div className="col-xl-8 col-lg-8">
                  <div className="rs-section-title-wrapper section-title-space text-center">
                    {/* <span className="rs-section-subtitle  has-bg-field">
                      Area of Applications
                    </span> */}
                    <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                      Area of{" "}
                      <span className="heading-highlight">Applications</span>{" "}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row g-5">
                <div className="col-xl-8 col-lg-8">
                  <div className="rs-portfolio-item">
                    {/* <div
                    className="rs-portfolio-bg-thumb"
                    data-background="assets/images/portfolio/portfolio-thumb-11.png"
                  ></div> */}
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner1.png)`,
                      }}
                    ></div>

                    <div className="rs-portfolio-content">
                      {/* <div className="rs-portfolio-tag">
                        <Link to="/"> Metallurgy</Link>
                      </div> */}
                      <h3 className="rs-portfolio-title underline has-white">
                        <div>
                          Automotive Technology Solutions <br /> For Factories
                        </div>
                      </h3>
                    </div>
                    {/* <div className="rs-portfolio-btn">
                      <Link
                        className="rs-btn has-theme-red has-circle has-icon"
                        to="/"
                      >
                        <span className="icon-box">
                          <svg
                            className="icon-first"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                          >
                            <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                          </svg>
                          <svg
                            className="icon-second"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                          >
                            <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                          </svg>
                        </span>
                      </Link>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <div className="rs-portfolio-item">
                    {/* <div
                    className="rs-portfolio-bg-thumb"
                    data-background="assets/images/portfolio/portfolio-thumb-12.png"
                  ></div> */}
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner4.png)`,
                      }}
                    ></div>

                    <div className="rs-portfolio-content">
                      {/* <div className="rs-portfolio-tag">
                        <Link to="/"> Metallurgy</Link>
                      </div> */}
                      <h3 className="rs-portfolio-title underline has-white">
                        <div>Casting & Foundry</div>
                      </h3>
                    </div>
                    {/* <div className="rs-portfolio-btn">
                      <Link
                        className="rs-btn has-theme-red has-circle has-icon"
                        to="/"
                      >
                        <span className="icon-box">
                          <svg
                            className="icon-first"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                          >
                            <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                          </svg>
                          <svg
                            className="icon-second"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                          >
                            <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                          </svg>
                        </span>
                      </Link>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <div className="rs-portfolio-item">
                    {/* <div
                    className="rs-portfolio-bg-thumb"
                    data-background="assets/images/portfolio/portfolio-thumb-13.png"
                  ></div> */}
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner3.png)`,
                      }}
                    ></div>

                    <div className="rs-portfolio-content">
                      <h3 className="rs-portfolio-title underline has-white">
                        <div> Die & Mould</div>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <div className="rs-portfolio-item">
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner7.png)`,
                      }}
                    ></div>
                    <div className="rs-portfolio-content">
                      <h3 className="rs-portfolio-title underline has-white">
                        <div>Medical</div>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <div className="rs-portfolio-item">
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner5.png)`,
                      }}
                    ></div>

                    <div className="rs-portfolio-content">
                      <h3 className="rs-portfolio-title underline has-white">
                        <div> General Engineering</div>
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div className="rs-portfolio-item">
                    {/* <div
                    className="rs-portfolio-bg-thumb"
                    data-background="assets/images/portfolio/portfolio-thumb-15.png"
                  ></div> */}
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner2.png)`,
                      }}
                    ></div>

                    <div className="rs-portfolio-content">
                      {/* <div className="rs-portfolio-tag">
                        <Link to="/"> Metallurgy</Link>
                      </div> */}
                      <h3 className="rs-portfolio-title underline has-white">
                        <div>Power & Energy</div>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-8">
                  <div className="rs-portfolio-item">
                    {/* <div
                    className="rs-portfolio-bg-thumb"
                    data-background="assets/images/portfolio/portfolio-thumb-11.png"
                  ></div> */}
                    <div
                      className="rs-portfolio-bg-thumb"
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/portfolio/banner6.png)`,
                      }}
                    ></div>

                    <div className="rs-portfolio-content">
                      {/* <div className="rs-portfolio-tag">
                        <Link to="/"> Metallurgy</Link>
                      </div> */}
                      <h3 className="rs-portfolio-title underline has-white">
                        <div>Aerospace Industry Solutions</div>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- portfolio area end -->

        <!-- testimonial area start --> */}
          {/* <section className="rs-testimonial-area rs-testimonial-three rs-swiper has-bg-blue">
            comment part
            <div
            className="rs-testimonial-bg-thumb"
            data-background="assets/images/testimonial/testimonial-thumb-01.png"
          ></div> comment part
            <div
              className="rs-testimonial-bg-thumb"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/img_testimonial_2.jpg)`,
              }}
            ></div>
            comment part
            <div
            className="rs-testimonial-bg-thumb-two"
            data-background="assets/images/bg/testimonials-bg-02.png"
          >
            {" "}
          </div> comment part
            <div
              className="rs-testimonial-bg-thumb-two"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/Testimonial.png)`,
              }}
            ></div>

            <div className="container">
              <div className="row justify-content-end">
                <div className="col-xxl-6 col-xl-7 col-lg-7">
                  <div className="rs-testimonial-wrapper">
                    <div className="rs-section-title-wrapper section-title-space">
                      <span className="rs-section-subtitle  has-bg-field justify-content-start">
                        Testimonials
                      </span>
                      <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                        what Client Say
                      </h2>
                    </div>
                    <div className="rs-testimonial-slider-wrapper">
                      <div
                        className="swiper"
                        data-clone-slides="false"
                        data-loop="true"
                        data-speed="1500"
                        data-autoplay="true"
                        data-dots-dynamic="false"
                        data-hover-pause="true"
                        data-effect="false"
                        data-delay="2500"
                        data-item="1"
                        data-item-xl="1"
                        data-item-lg="1"
                        data-item-md="1"
                        data-item-sm="1"
                        data-item-xs="1"
                        data-item-mobile="1"
                        data-margin="30"
                        data-margin-xl="30"
                      >
                        <div className="swiper-wrapper">
                          <div className="swiper-slide">
                            <div className="rs-testimonial-item">
                              <div className="rs-testimonial-avater-thumb">
                                <div className="rs-testimonial-thumb">
                                  <img
                                    src="/assets/images/user/user-thumb-01.png"
                                    alt="testimonial-user"
                                  />
                                </div>
                                <div className="rs-testimonial-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="29"
                                    viewBox="0 0 40 29"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.85714 29H11.4286L17.1429 17.4V0H0V17.4H8.57143L2.85714 29ZM25.7143 29H34.2857L40 17.4V0H22.8571V17.4H31.4286L25.7143 29Z"
                                      fill="white"
                                      fillOpacity="0.4"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <div className="rs-testimonial-content">
                                <h5 className="rs-testimonial-title">
                                  Best Company
                                </h5>
                                <div className="rs-testimonial-description">
                                  <p>
                                    Podcasting operational change management
                                    inside of workflows to establish a framework
                                    Taking seamless key performance indicators.
                                  </p>
                                </div>
                                <div className="rs-tesimonial-avater-info">
                                  <h6 className="rs-testimonial-avater-title">
                                    Nayeem
                                  </h6>
                                  <span className="rs-testimonial-avater-designation">
                                    Manager
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="swiper-slide">
                            <div className="rs-testimonial-item">
                              <div className="rs-testimonial-avater-thumb">
                                <div className="rs-testimonial-thumb">
                                  <img
                                    src="/assets/images/user/user-thumb-02.png"
                                    alt="testimonial-user"
                                  />
                                </div>
                                <div className="rs-testimonial-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="29"
                                    viewBox="0 0 40 29"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.85714 29H11.4286L17.1429 17.4V0H0V17.4H8.57143L2.85714 29ZM25.7143 29H34.2857L40 17.4V0H22.8571V17.4H31.4286L25.7143 29Z"
                                      fill="white"
                                      fillOpacity="0.4"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <div className="rs-testimonial-content">
                                <h5 className="rs-testimonial-title">
                                  Best Company
                                </h5>
                                <div className="rs-testimonial-description">
                                  <p>
                                    Podcasting operational change management
                                    inside of workflows to establish a framework
                                    Taking seamless key performance indicators.
                                  </p>
                                </div>
                                <div className="rs-tesimonial-avater-info">
                                  <h6 className="rs-testimonial-avater-title">
                                    Abdur Rashid
                                  </h6>
                                  <span className="rs-testimonial-avater-designation">
                                    Founder &amp; CEO
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="swiper-slide">
                            <div className="rs-testimonial-item">
                              <div className="rs-testimonial-avater-thumb">
                                <div className="rs-testimonial-thumb">
                                  <img
                                    src="/assets/images/user/user-thumb-03.png"
                                    alt="testimonial-user"
                                  />
                                </div>
                                <div className="rs-testimonial-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="29"
                                    viewBox="0 0 40 29"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.85714 29H11.4286L17.1429 17.4V0H0V17.4H8.57143L2.85714 29ZM25.7143 29H34.2857L40 17.4V0H22.8571V17.4H31.4286L25.7143 29Z"
                                      fill="white"
                                      fillOpacity="0.4"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <div className="rs-testimonial-content">
                                <h5 className="rs-testimonial-title">
                                  Best Company
                                </h5>
                                <div className="rs-testimonial-description">
                                  <p>
                                    Podcasting operational change management
                                    inside of workflows to establish a framework
                                    Taking seamless key performance indicators.
                                  </p>
                                </div>
                                <div className="rs-tesimonial-avater-info">
                                  <h6 className="rs-testimonial-avater-title">
                                    Tom Hanks
                                  </h6>
                                  <span className="rs-testimonial-avater-designation">
                                    Customer
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- If we need navigation buttons -->
                        <div className=" rs-testimonial-navigation">
                          <button className="swiper-button-prev rs-swiper-btn has-light-red">
                            <i className="fa-regular fa-arrow-left"></i>
                          </button>
                          <button className="swiper-button-next rs-swiper-btn has-light-red">
                            <i className="fa-regular fa-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* <!-- testimonial area end -->

        <!-- blog area start --> */}

          {/* <!-- blog area end --> */}

          <div className="rs-brand-thumb-wrapper">
            {/* <div
            className="rs-brand-bg-thumb"
            data-background="assets/images/bg/brand-bg-02.png"
          ></div> */}
            <div
              className="rs-brand-bg-thumb"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/bg/brand-bg-02.png)`,
              }}
            ></div>

            {/* <!-- brand area start --> */}
            {/* <div className="rs-brand-area rs-brand-three section-space">
              <div className="container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="rs-brand-wrapper">
                      <div
                        className="rs-brand-item wow fadeIn"
                        data-wow-delay=".3s"
                      >
                        <div className="rs-brand-thumb">
                          <img
                            src="/assets/images/brand/brand-thumb-09.png"
                            alt="brand-name"
                          />
                        </div>
                      </div>
                      <div
                        className="rs-brand-item wow fadeIn"
                        data-wow-delay=".5s"
                      >
                        <div className="rs-brand-thumb">
                          <img
                            src="/assets/images/brand/brand-thumb-10.png"
                            alt="brand-name"
                          />
                        </div>
                      </div>
                      <div
                        className="rs-brand-item wow fadeIn"
                        data-wow-delay=".7s"
                      >
                        <div className="rs-brand-thumb">
                          <img
                            src="/assets/images/brand/brand-thumb-11.png"
                            alt="brand-name"
                          />
                        </div>
                      </div>
                      <div
                        className="rs-brand-item wow fadeIn"
                        data-wow-delay=".9s"
                      >
                        <div className="rs-brand-thumb">
                          <img
                            src="/assets/images/brand/brand-thumb-12.png"
                            alt="brand-name"
                          />
                        </div>
                      </div>
                      <div
                        className="rs-brand-item wow fadeIn"
                        data-wow-delay="1.1s"
                      >
                        <div className="rs-brand-thumb">
                          <img
                            src="/assets/images/brand/brand-thumb-13.png"
                            alt="brand-name"
                          />
                        </div>
                      </div>
                      <div
                        className="rs-brand-item wow fadeIn"
                        data-wow-delay="1.3s"
                      >
                        <div className="rs-brand-thumb">
                          <img
                            src="/assets/images/brand/brand-thumb-14.png"
                            alt="brand-name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <!-- brand area end -->


              {/* contact us start*/}

            <section
              id="homecontact"
              className="rs-contact-area rs-contact-one section-space has-theme-orange p-relative contact-section-wrapping"
            >
              <div
                className="rs-contact-bg-thumb"
                // data-background="assets/images/bg/contact-bg-04.jpg"
              ></div>
              <div className="container">
                <div className="row align-items-xl-center g-5">
                  <div className="col-xl-7 col-lg-7">
                    <div className="rs-contact-wrapper">
                      <div className="rs-section-title-wrapper">
                        <span className="rs-section-subtitle has-theme-orange justify-content-start">
                          Contact
                        </span>
                        <h2 className="rs-section-title mb-30 rs-split-text-enable split-in-fade">
                          Let’s Talk About Your Tooling Requirements
                        </h2>
                        <p className="descrip">
                          Connect with Pristine Precision Tools for all your
                          needs of cutting tools solutions built for your
                          machining requirements. Our experts help you achieve
                          accuracy, efficiency, and dependable performance.
                        </p>
                      </div>

                      <div className="rs-contact-list">
                        <div
                          className="rs-contact-list-item wow fadeIn"
                          data-wow-delay=".7s"
                        >
                          <div className="rs-contact-icon">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M2 2C0.895431 2 0 2.89543 0 4V12L2.58386e-05 12.0103C0.00555998 13.1101 0.898859 14 2 14H7.5C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13H2C1.53715 13 1.14774 12.6855 1.03376 12.2586L6.67417 8.7876L8 9.5831L15 5.3831V8.5C15 8.77614 15.2239 9 15.5 9C15.7761 9 16 8.77614 16 8.5V4C16 2.89543 15.1046 2 14 2H2ZM5.70808 8.20794L1 11.1052V5.3831L5.70808 8.20794ZM1 4.2169V4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4V4.2169L8 8.4169L1 4.2169Z"
                                  fill="#6D6D6D"
                                ></path>
                                <path
                                  d="M14.2467 14.2686C15.2567 14.2686 15.8339 13.4116 15.8339 12.2442V12.0344C15.8339 10.4297 14.6402 9 12.5197 9H12.4847C10.421 9 9 10.3598 9 12.4322V12.6465C9 14.8195 10.4385 16 12.3579 16H12.4016C12.9963 16 13.4204 15.9257 13.639 15.8251V15.0949C13.3941 15.2042 12.9656 15.2742 12.4585 15.2742H12.4147C11.0812 15.2742 9.84385 14.4872 9.84385 12.6202V12.4628C9.84385 10.8057 10.9019 9.73891 12.4847 9.73891H12.524C14.0587 9.73891 15.0075 10.7883 15.0075 12.065V12.183C15.0075 13.158 14.6839 13.5734 14.3691 13.5734C14.1374 13.5734 13.9582 13.4247 13.9582 13.1537V10.9631H13.0531V11.5315H13.0225C12.9394 11.2342 12.6552 10.9019 12.0693 10.9019C11.2911 10.9019 10.8101 11.4572 10.8101 12.3011V12.8301C10.8101 13.722 11.2998 14.2642 12.0693 14.2642C12.5415 14.2642 12.9656 14.0369 13.0837 13.6215H13.1274C13.2455 14.0412 13.7439 14.2686 14.2467 14.2686ZM11.7939 12.6814V12.4541C11.7939 11.9076 12.0212 11.6627 12.3666 11.6627C12.664 11.6627 12.9394 11.8551 12.9394 12.371V12.7383C12.9394 13.3111 12.6858 13.4816 12.3754 13.4816C12.0212 13.4816 11.7939 13.2673 11.7939 12.6814Z"
                                  fill="#6D6D6D"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <div className="rs-contact-list-content">
                            <span>Email Address</span>
                            <p> Interested in working with us?</p>
                            <h6>
                              <Link
                                to={`mailto:${process.env.REACT_APP_EMAIL2}`}
                              >
                                {process.env.REACT_APP_EMAIL2}
                              </Link>
                            </h6>
                          </div>
                        </div>
                        <div
                          className="rs-contact-list-item wow fadeIn"
                          data-wow-delay=".5s"
                        >
                          <div className="rs-contact-icon">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <path
                                  d="M23.7225 18.5848C23.1074 17.9453 22.3655 17.6034 21.5792 17.6034C20.7993 17.6034 20.051 17.9389 19.4106 18.5784L17.4068 20.573C17.242 20.4843 17.0771 20.402 16.9186 20.3197C16.6903 20.2057 16.4747 20.0981 16.2908 19.9841C14.4139 18.7937 12.7081 17.2424 11.0722 15.2353C10.2795 14.2348 9.74688 13.3927 9.36008 12.5379C9.88004 12.063 10.362 11.5691 10.8312 11.0943C11.0087 10.917 11.1863 10.7333 11.3638 10.556C12.6955 9.22637 12.6955 7.50412 11.3638 6.17444L9.63274 4.44585C9.43617 4.24957 9.23326 4.04695 9.04303 3.84433C8.66256 3.45176 8.26308 3.04652 7.85091 2.66662C7.23583 2.05876 6.50028 1.73584 5.72667 1.73584C4.95307 1.73584 4.20483 2.05876 3.57072 2.66662C3.56438 2.67295 3.56438 2.67295 3.55804 2.67928L1.40209 4.85109C0.590443 5.66156 0.127549 6.64932 0.0260924 7.79538C-0.126092 9.64427 0.419236 11.3665 0.837743 12.4936C1.86499 15.2606 3.39952 17.825 5.68862 20.573C8.46599 23.8845 11.8077 26.4995 15.625 28.3421C17.0834 29.0323 19.0301 29.8491 21.2051 29.9884C21.3383 29.9947 21.4778 30.001 21.6046 30.001C23.0694 30.001 24.2995 29.4755 25.2634 28.4307C25.2697 28.4181 25.2824 28.4117 25.2887 28.3991C25.6185 28.0002 25.9989 27.6393 26.3984 27.253C26.6711 26.9934 26.9501 26.7212 27.2227 26.4362C27.8505 25.784 28.1802 25.0242 28.1802 24.2454C28.1802 23.4603 27.8442 22.7068 27.2037 22.0736L23.7225 18.5848ZM25.9926 25.2522C25.9862 25.2522 25.9862 25.2585 25.9926 25.2522C25.7453 25.5181 25.4916 25.7587 25.219 26.0247C24.8068 26.4172 24.3883 26.8288 23.9952 27.291C23.3547 27.9749 22.6001 28.2978 21.6109 28.2978C21.5158 28.2978 21.4144 28.2978 21.3192 28.2914C19.436 28.1711 17.6858 27.4366 16.3732 26.8098C12.7842 25.0749 9.63274 22.6118 7.0139 19.4902C4.85161 16.8879 3.40586 14.4818 2.44836 11.8984C1.85865 10.3218 1.64305 9.0934 1.73817 7.93468C1.80158 7.19386 2.08692 6.57967 2.61323 6.05413L4.77552 3.89499C5.08623 3.60372 5.41596 3.44543 5.73935 3.44543C6.13884 3.44543 6.46223 3.68604 6.66514 3.88865C6.67148 3.89499 6.67782 3.90132 6.68417 3.90765C7.07097 4.26856 7.43875 4.64214 7.82555 5.04104C8.02212 5.24366 8.22503 5.44628 8.42795 5.65523L10.159 7.38381C10.8312 8.05498 10.8312 8.6755 10.159 9.34667C9.97515 9.5303 9.79761 9.71392 9.61372 9.89121C9.08107 10.4357 8.57379 10.9423 8.02212 11.4362C8.00944 11.4488 7.99676 11.4552 7.99042 11.4678C7.44509 12.0124 7.54654 12.5442 7.66068 12.9051C7.66702 12.9241 7.67336 12.9431 7.67971 12.9621C8.12992 14.0512 8.76402 15.077 9.72785 16.299L9.7342 16.3053C11.4843 18.4581 13.3296 20.1361 15.365 21.4214C15.625 21.5861 15.8913 21.719 16.145 21.8457C16.3732 21.9596 16.5888 22.0673 16.7727 22.1812C16.7981 22.1939 16.8235 22.2129 16.8488 22.2256C17.0644 22.3332 17.2673 22.3839 17.4766 22.3839C18.0029 22.3839 18.3326 22.0546 18.4404 21.947L20.609 19.7815C20.8246 19.5662 21.1671 19.3066 21.5665 19.3066C21.9597 19.3066 22.2831 19.5535 22.4796 19.7688C22.486 19.7752 22.486 19.7752 22.4923 19.7815L25.9862 23.2703C26.6394 23.9162 26.6394 24.581 25.9926 25.2522Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M16.2163 7.13613C17.8777 7.41473 19.3869 8.19988 20.5917 9.40292C21.7964 10.606 22.5764 12.1129 22.8617 13.7719C22.9315 14.1898 23.2929 14.481 23.7051 14.481C23.7558 14.481 23.8002 14.4747 23.8509 14.4684C24.3202 14.3924 24.6309 13.9492 24.5548 13.4806C24.2124 11.4734 23.2612 9.64353 21.8091 8.19355C20.357 6.74356 18.5245 5.79379 16.5144 5.45187C16.0451 5.37589 15.6076 5.68615 15.5252 6.14837C15.4427 6.61059 15.7471 7.06015 16.2163 7.13613Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M29.9883 13.2338C29.4239 9.92864 27.864 6.92103 25.4671 4.52761C23.0702 2.13419 20.0582 0.576563 16.7482 0.0130318C16.2853 -0.0692817 15.8478 0.247309 15.7654 0.709531C15.6893 1.17808 16 1.61498 16.4692 1.69729C19.4241 2.19751 22.1191 3.59683 24.2623 5.73065C26.4056 7.8708 27.8006 10.5618 28.3016 13.5124C28.3713 13.9303 28.7328 14.2216 29.1449 14.2216C29.1956 14.2216 29.24 14.2153 29.2908 14.2089C29.7537 14.1393 30.0707 13.6961 29.9883 13.2338Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <div className="rs-contact-list-content">
                            <span>Phone Number</span>
                            <h6 className="mb-5">
                              <Link to={`tel:${process.env.REACT_APP_PHONE1}`}>
                                {process.env.REACT_APP_PHONE1}
                              </Link>
                            </h6>
                            <h6>
                              <Link to={`tel:${process.env.REACT_APP_PHONE2}`}>
                                {process.env.REACT_APP_PHONE2}
                              </Link>
                            </h6>
                          </div>
                        </div>
                        <div
                          className="rs-contact-list-item wow fadeIn"
                          data-wow-delay=".3s"
                        >
                          <div className="rs-contact-icon">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="35"
                                viewBox="0 0 30 35"
                                fill="none"
                              >
                                <path
                                  d="M20.6984 22.653C24.3306 16.928 23.874 17.6423 23.9787 17.493C25.3011 15.6195 26 13.4144 26 11.1161C26 5.02098 21.0759 0 15 0C8.94387 0 4 5.01107 4 11.1161C4 13.4129 4.7136 15.6757 6.07933 17.5745L9.30147 22.6531C5.85647 23.1848 0 24.7696 0 28.2589C0 29.5309 0.826533 31.3436 4.76413 32.7562C7.5136 33.7425 11.1487 34.2857 15 34.2857C22.2017 34.2857 30 32.2452 30 28.2589C30 24.7689 24.1504 23.1859 20.6984 22.653ZM7.74993 16.4695C7.73893 16.4523 7.72747 16.4354 7.71547 16.4188C6.579 14.8483 6 12.9871 6 11.1161C6 6.09254 10.0271 2.00893 15 2.00893C19.9626 2.00893 24 6.09435 24 11.1161C24 12.9901 23.4319 14.7882 22.3569 16.3173C22.2606 16.4449 22.7632 15.6606 15 27.8966L7.74993 16.4695ZM15 32.2768C7.13373 32.2768 2 29.9543 2 28.2589C2 27.1195 4.63787 25.2459 10.4832 24.5156L14.1567 30.3055C14.3403 30.5949 14.6583 30.7701 14.9999 30.7701C15.3416 30.7701 15.6597 30.5948 15.8432 30.3055L19.5166 24.5156C25.3621 25.2459 28 27.1195 28 28.2589C28 29.9399 22.9125 32.2768 15 32.2768Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M15.0039 6.09375C12.2469 6.09375 10.0039 8.34676 10.0039 11.1161C10.0039 13.8854 12.2469 16.1384 15.0039 16.1384C17.7609 16.1384 20.0039 13.8854 20.0039 11.1161C20.0039 8.34676 17.7609 6.09375 15.0039 6.09375ZM15.0039 14.1295C13.3497 14.1295 12.0039 12.7777 12.0039 11.1161C12.0039 9.45449 13.3497 8.10268 15.0039 8.10268C16.6581 8.10268 18.0039 9.45449 18.0039 11.1161C18.0039 12.7777 16.6581 14.1295 15.0039 14.1295Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <div className="rs-contact-list-content">
                            <span>Our Address</span>
                            <h6>
                              <Link to="#">
                                {" "}
                                {process.env.REACT_APP_FOOTER_ADDRESS}
                              </Link>
                            </h6>
                          </div>
                        </div>
                        <div
                          className="rs-contact-list-item wow fadeIn"
                          data-wow-delay=".9s"
                        >
                          <div className="rs-contact-icon">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                id="Outline"
                                viewBox="0 0 24 24"
                                width="512"
                                height="512"
                              >
                                <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"></path>
                                <path d="M12,6a1,1,0,0,0-1,1v4.325L7.629,13.437a1,1,0,0,0,1.062,1.7l3.84-2.4A1,1,0,0,0,13,11.879V7A1,1,0,0,0,12,6Z"></path>
                              </svg>
                            </span>
                          </div>
                          <div className="rs-contact-list-content">
                            <span>Opening Hour</span>
                            <p className="">Thursday - Tuesday 24 Hrs</p>
                            <p className="">Wednesday - Closed</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-5">
                    <div
                      className="rs-contact-form wow fadeInRight"
                      data-wow-delay=".3s"
                      data-wow-duration="1s"
                    >
                      <div
                        className="rs-contact-form-bg-thumb"
                        data-background="assets/images/bg/contact-bg-03.png"
                      ></div>
                      <h3 className="rs-contact-form-title">Get in Touch</h3>
                      <p className="descrip">
                        The point of using Lorem Ipsum is that it has
                        more-or-less normal
                      </p>
                      <form id="contact-form" onSubmit={handlesubmit}>
                        <div className="row g-4">
                          <div className="col-md-12">
                            <div className="rs-contact-input">
                              <input
                                id="name"
                                name="username"
                                type="text"
                                placeholder="Full Name"
                                onChange={handlechange}
                                value={fromdata.username}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="rs-contact-input">
                              <input
                                id="email"
                                name="email"
                                type="email"
                                placeholder="Email Address"
                                onChange={handlechange}
                                value={fromdata.email}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="rs-contact-input">
                              <input
                                id="phone"
                                name="mobileno"
                                type="text"
                                placeholder="Phone Number"
                                onChange={handlechange}
                                value={fromdata.mobileno}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="rs-contact-input">
                              <textarea
                                id="message"
                                name="message"
                                placeholder="Write Your Message"
                                onChange={handlechange}
                                value={fromdata.message}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="rs-contact-btn rs-contact-btn-hover">
                              <button type="submit" className="rs-btn black-bg">
                                Send Message
                              </button>
                              {successMsg && (
                                <p
                                  style={{ color: "black", marginTop: "10px" }}
                                >
                                  {successMsg}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* contact us end */}

            {/* <!-- cta area start -->  */}
            {/* <section className="subscribe-area">
              <div className="container">
                <div className="row cta-area">
                  <div className="col-xl-10 col-md-10">
                    <div className="subscribe-title">
                      <h3>
                        Get Started with Pristine Precision Tools International
                        Today!{" "}
                      </h3>
                    </div>
                  </div>
                  <div className="col-xl-2 col-md-10 text-right">
                    <Link
                      className="btn-one bg-blue bg-hover-white text-transform-none"
                      to={`tel:${process.env.REACT_APP_PHONE1}`}
                      title="Call Pristine Precision Tools International - Expert Support &amp; Industrial Solutions"
                    >
                      <span className="icon-phone-call">
                        {" "}
                        <i className="fa-solid fa-phone subscribe-call"></i>
                      </span>{" "}
                      Give us a call
                    </Link>
                  </div>
                </div>
              </div>
            </section> */}
            {/* <!-- cta area end --> */}
          </div>
        </main>

        <Footer />
        {/* Backtotop start  */}
        <div className="backtotop-wrap cursor-pointer has-theme-red">
          <svg
            className="backtotop-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        </div>
        {/* <!-- Backtotop end --> */}

        {/* whatsapp start  */}
        <div
          className="backtotop-wrap2 cursor-pointer2 has-theme-red2"
          onClick={handleClick}
        >
          <i className="fa-brands fa-whatsapp backtotop-circle2 svg-content2"></i>
        </div>
        {/* <!-- whatsapp end --> */}
      </>
    </>
  );
}

export default Home;
